module.exports = __webpack_public_path__ + "static/media/1.3cf5767b.png";